import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sgzp-app4-unblock',
  templateUrl: './sgzp-app4-unblock.component.html',
  styleUrls: ['./sgzp-app4-unblock.component.css', '../style/global.css'],
})
export class SgzpApp4UnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get logoUrl() {
    return environment.apps[this.clientId].oemConfig?.imgpath || '/assets/sgzp-app4/images/logo.svg'
  }

  get appname() {
    return environment.apps[this.clientId].oemConfig?.name || '処方元情報システム';
  }
}
